// export const URL_BASE = "https://api.mendozacreativa.com/";
// export const INTEREST_PLACES = "interest_places";
// export const STORAGE_URL = "https://api.mendozacreativa.com/";
// export const IMAGE_URL = STORAGE_URL + "images/photos/";

export const URL_BASE = process.env.REACT_APP_URL_API_BACKEND+"/api/admin/";
export const STORAGE_URL = process.env.REACT_APP_URL_API_BACKEND ;

